import { ExpandLess, ExpandMore } from "@mui/icons-material";
import { Box, ClickAwayListener, ListItemButton, ListItemText } from "@mui/material";
import Collapse from "@mui/material/Collapse";
import List from "@mui/material/List";
import { useState } from "react";
import { Link, useLocation } from "react-router";


interface PropTypes {
    title: string;
    items: Array<NavItem>;
}

function NavDropDown({ title, items }: PropTypes) {
    const location = useLocation();

    const [open, setOpen] = useState(items.filter((item) => item.to === location.pathname).length > 0);

    const close = (): void => setOpen(false);
    const toggle = (): void => setOpen((prevState) => !prevState);

    return (
        <ClickAwayListener onClickAway={close}>
            <Box>
                <ListItemButton
                    onClick={toggle}
                >
                    <ListItemText>{title}</ListItemText>
                    {open ? <ExpandLess /> : <ExpandMore />}
                </ListItemButton>

                <Collapse in={open} timeout="auto" unmountOnExit>
                    <List disablePadding>
                        {items.map((item) => (
                            <ListItemButton
                                key={item.title}
                                component={Link}
                                to={item.to}
                                selected={item.to === location.pathname}
                                sx={{ pl: 4 }}
                            >
                                <ListItemText>{item.title}</ListItemText>
                            </ListItemButton>

                        ))}

                    </List>
                </Collapse>

            </Box>
        </ClickAwayListener>
    );
}

export default NavDropDown;